<!--
  A single-choice picker with a search box. A thin wrapper over PickList (:multiple="false"),
  kept so the pages that already use SearchSelect don't change.
-->
<template>
  <PickList :multiple="false" :items="items" :model-value="modelValue" :text-field="textField" :key-field="dataItemKey"
            :label="label" :disabled="disabled" @change="onChange" />
</template>

<script>
import PickList from './PickList.vue'

export default {
  name: 'SearchSelect',
  components: { PickList },
  props: {
    modelValue: { type: [String, Number, Object], default: null },
    items: { type: Array, default: () => [] },
    textField: { type: String, default: '' },
    dataItemKey: { type: String, default: '' },
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  emits: ['update:modelValue', 'change'],
  methods: {
    onChange(v) {
      this.$emit('update:modelValue', v)
      this.$emit('change', v)
    }
  }
}
</script>
